export const FETCH_LINK_BY_TOKEN = "FETCH_LINK_BY_TOKEN";
export const FETCH_LINK_BY_TOKEN_SUCCESS = "FETCH_LINK_BY_SUCCESS";
export const FETCH_LINK_BY_TOKEN_FAILURE = "FETCH_LINK_BY_FAILURE";
export const RESET_FETCH_LINK_BY_TOKEN  = "RESET_FETCH_LINK_BY_TOKEN";

export const VALIDATE_LINK_BY_TOKEN = "VALIDATE_LINK_BY_TOKEN";
export const VALIDATE_LINK_BY_TOKEN_SUCCESS = "VALIDATE_LINK_BY_TOKEN_SUCCESS";
export const VALIDATE_LINK_BY_TOKEN_FAILURE = "VALIDATE_LINK_BY_TOKEN_FAILURE";

export const CREATE_LINK =  "CREATE_LINK";
export const CREATE_LINK_SUCCESS =  "CREATE_LINK_SUCCESS";
export const CREATE_LINK_FAILURE =  "CREATE_LINK_FAILURE";
